import { ReactNode } from 'react';

const HeaderTitle = ({ title, icons }: { title: string; icons: ReactNode }) => {
  return (
    <div className="fixed top-0 left-0 w-full z-10 bg-[#18171C]">
      <div className="w-full max-w-939 flex h-58 mx-auto items-center px-20 justify-between">
        <h1 className="text-[20px] text-[#C9C7D1] font-bold">{title}</h1>
        {icons}
      </div>
    </div>
  );
};

export default HeaderTitle;
